import { agentApi } from "@/getinfo-api";
import { getCurrentCompanyId } from "@/plugins/roles";
import { checkEmptyParams } from "@/utils/checker-helper";
import { Payment as IPayment } from "@/api-v2/agent/models/payment";
import { PaymentEdit as IBillPaymentEdit } from "@/api/models/payment-edit";
import api from "@/getinfo-api";

interface AgentReportsBillParams {
  companyId: string;
  agentId?: string;
  responsibleId?: string;
  contractorId?: string;
  paid?: boolean;
  offset?: number;
  limit?: number;
  sort?: "createdAt" | "formedAt";
  order?: "ASC" | "DESC";
  options?: any;
}

interface AgentReportsPaymentParams {
  companyId: string;
  agentId?: string;
  responsibleId?: string;
  contractorId?: string;
  paidToAgent?: boolean;
  paymentAtMin?: Date;
  paymentAtMax?: Date;
  offset?: number;
  limit?: number;
  sort?: "createdAt" | "paymentAt";
  order?: "ASC" | "DESC";
  options?: any;
}

const setTmpFilterParams = (
  params: AgentReportsBillParams | AgentReportsPaymentParams
) => {
  agentsReports.tmpFilterParams = params;
};
const agentsReports = {
  tmpFilterParams: {} as AgentReportsBillParams | AgentReportsPaymentParams,

  bills: async (params?: AgentReportsBillParams) => {
    const defaultParams: AgentReportsBillParams = {
      companyId: getCurrentCompanyId(),
      sort: "formedAt",
      order: "DESC",
      limit: 30,
      offset: 0
    };

    const _params = checkEmptyParams({ ...defaultParams, ...params });
    setTmpFilterParams(_params);

    return agentApi.Agent.agentBills(
      _params.companyId,
      _params.agentId,
      _params.responsibleId,
      _params.contractorId,
      _params.paid,
      _params.offset,
      _params.limit,
      _params.sort,
      _params.order,
      _params.options
    );
  },

  payments: async (params?: AgentReportsPaymentParams) => {
    const defaultParams: AgentReportsPaymentParams = {
      companyId: getCurrentCompanyId(),
      sort: "paymentAt",
      order: "DESC",
      limit: 30,
      offset: 0
    };

    const _params = checkEmptyParams({ ...defaultParams, ...params });
    setTmpFilterParams(_params);

    return agentApi.Agent.agentPayments(
      _params.companyId,
      _params.agentId,
      _params.responsibleId,
      _params.contractorId,
      _params.paidToAgent,
      _params.paymentAtMin,
      _params.paymentAtMax,
      _params.offset,
      _params.limit,
      _params.sort,
      _params.order,
      _params.options
    );
  },

  getParamsForShowMore: function() {
    this.tmpFilterParams.offset =
      (this.tmpFilterParams.offset ?? 0) + this.tmpFilterParams!.limit!;
    return this.tmpFilterParams as
      | AgentReportsPaymentParams
      | AgentReportsBillParams;
  },

  changeOrder: function(order: "DESC" | "ASC") {
    this.tmpFilterParams.order = order;
    return this.tmpFilterParams as
      | AgentReportsPaymentParams
      | AgentReportsBillParams;
  },

  editAgentPaymentAt: async (payments: IPayment[], date: Date) => {
    return await Promise.allSettled(
      payments?.map(async payment => {
        const agentPaymentDate: IBillPaymentEdit = {
          agentPaymentAt: date
        };

        await api.BillApi.editPayment(
          payment.billId,
          payment.id,
          agentPaymentDate
        );
      })
    );
  }
};

export { agentsReports, AgentReportsBillParams, AgentReportsPaymentParams };
